import React from 'react';
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';
import { BodyTextMedium, HeadingText20, HeadingText50 } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';

import * as Constants from 'src/shared/data/constants';

import messages from './CommunityGuidelines.messages';

const Wrapper = styled.div({
  paddingBottom: 100,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const ContentContainer = styled.div({
  width: 800,
  maxWidth: '90vw',
});

const HeadingWrapper = styled.div({
  marginBottom: 32,
});

const StyledList = styled.ul`
  list-style: disc;
  padding: 24px;
  max-width: 750px;

  & > li {
    &::marker {
      color: ${colors.gray65};
    }

    margin-bottom: 24px;
  }
`;

const CodeOfConduct: React.FC<unknown> = () => {
  return (
    <Wrapper>
      <ContentContainer>
        <HeadingWrapper>
          <HeadingText50 fontColor="gray85" css={{ marginBottom: '1rem' }}>
            <FormattedMessage
              defaultMessage="<bold>Circles</bold> Community Guidelines"
              values={{
                bold: (chunk: string) => <span css={{ color: colors.blue55 }}>{chunk}</span>,
              }}
            />
          </HeadingText50>
          <BodyTextMedium fontColor="gray65">
            <FormattedMessage
              description="Community Guidelines Introduction"
              defaultMessage="To create an environment for everyone to learn and grow, all Circle attendees must abide by the guidelines below. <i>If the session facilitator determines any participant is in violation of the Code of Conduct, they may be asked to leave the session.</i>"
              values={{
                i: (chunk: string) => <span css={{ fontStyle: 'italic' }}>{chunk}</span>,
              }}
            />
          </BodyTextMedium>
        </HeadingWrapper>

        <StyledList>
          {messages.bullets.map((message, i) => (
            <li key={i}>
              <div>
                <FormattedMessage
                  {...message}
                  values={{
                    'terms-of-use-link': (chunk: string) => (
                      <a target="_blank" rel="noreferrer" href={Constants.TERMS_OF_USE_URL}>
                        {chunk}
                      </a>
                    ),
                    bold: (chunk: string) => (
                      <HeadingText20 as="span" fontColor="black" css={{ fontWeight: 600 }}>
                        {chunk}
                      </HeadingText20>
                    ),
                  }}
                >
                  {chunk => <BodyTextMedium fontColor="gray65">{chunk}</BodyTextMedium>}
                </FormattedMessage>
              </div>
            </li>
          ))}
        </StyledList>
      </ContentContainer>
    </Wrapper>
  );
};

export default CodeOfConduct;
